export default __webpack_public_path__ + "static/media/ico-aws-user-circle-solid.efe3c26d.svg";